import Personas from "./personas";

export default Personas;